import styled from 'styled-components/macro'
import ExpandDown from '../../../assets/icon_accordion_down.svg'

export const ExpandIcon = styled.div`
  background: url(${ExpandDown});
  height: 24px;
  width: 24px;
`
